import { dateIsToday, timeStampToDateTimeLocal, calculateDurationBetweenDates } from "../global/utils";
import {Subject} from '../components/Subject' 

export default class TodoItem extends Subject {
    constructor(
        data={
            id:-1,
            content:'',
            done:false,
            due_date:'',
            start_date:'',
        },
    ) {
        super()

        this.id = data.id;
        this.content = data.content;
        this.done = data.done;
        this.dueDate = data.due_date;
        this.startDate = data.start_date;
        this.duration = 0;

        if ( this.dueDate && this.startDate ) {
            this.duration = calculateDurationBetweenDates(this.dueDate, this.startDate);
        }
    }

    getId() {
        return this.id;
    }

    getContent() {
        return this.content;
    }

    getDone() {
        return this.done;
    }

    getDueDate() {
        return this.dueDate;
    }

    getStartDate() {
        return this.startDate;
    }

    setDone(done=true) {
        this.done = done;
    }

    markDone() {
        this.done = true;
    }

    toggleDoneState() {
        this.done = !this.done;
    }

    dueToday() {
        return dateIsToday(this.dueDate);
    }

    startsToday() {
        return dateIsToday(this.startDate);
    }

    toObject() {
        return {
            id: this.id,
            content: this.content,
            done: this.done,
            due_date: this.dueDate,
            start_date: this.startDate,
            duration: this.duration,
        };
    }

    toFormObject() {
        const obj = {
            id: this.id,
            content: this.content,
            duration: this.duration,
        }

        if ( this.dueDate ) {
            obj.due_date = timeStampToDateTimeLocal(this.dueDate);
        }

        if ( this.startDate ) {
            obj.start_date = timeStampToDateTimeLocal(this.startDate);
        }
        
        return obj;
    }
}
